/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geostyledots2Inputs */

const en_geostyledots2 = /** @type {(inputs: Geostyledots2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dots`)
};

const de_geostyledots2 = /** @type {(inputs: Geostyledots2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punkte`)
};

/**
* | output |
* | --- |
* | "Dots" |
*
* @param {Geostyledots2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geostyledots2 = /** @type {((inputs?: Geostyledots2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geostyledots2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geostyledots2(inputs)
	return de_geostyledots2(inputs)
});
export { geostyledots2 as "geoStyleDots" }